var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInfoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1.1875C3.34213 1.1875 1.1875 3.34213 1.1875 6C1.1875 8.65787 3.34213 10.8125 6 10.8125C8.65787 10.8125 10.8125 8.65787 10.8125 6C10.8125 3.34213 8.65787 1.1875 6 1.1875ZM0.3125 6C0.3125 2.85888 2.85888 0.3125 6 0.3125C9.14112 0.3125 11.6875 2.85888 11.6875 6C11.6875 9.14112 9.14112 11.6875 6 11.6875C2.85888 11.6875 0.3125 9.14112 0.3125 6ZM5.125 5.5625C5.125 5.32088 5.32088 5.125 5.5625 5.125H6C6.24162 5.125 6.4375 5.32088 6.4375 5.5625V8.1875C6.67912 8.1875 6.875 8.38338 6.875 8.625C6.875 8.86662 6.67912 9.0625 6.4375 9.0625H6C5.75838 9.0625 5.5625 8.86662 5.5625 8.625V6C5.32088 6 5.125 5.80412 5.125 5.5625ZM6.65625 3.59375C6.65625 3.95619 6.36244 4.25 6 4.25C5.63756 4.25 5.34375 3.95619 5.34375 3.59375C5.34375 3.23131 5.63756 2.9375 6 2.9375C6.36244 2.9375 6.65625 3.23131 6.65625 3.59375Z",
    fill: "#6ab6f0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoLight);
export default __webpack_public_path__ + "static/media/ic_info_light.7a8114c4.svg";
export { ForwardRef as ReactComponent };